import { Select } from '@mui/material';
import { styled } from '@mui/material/styles';

import { COLOR, COLOR_FUNCTION } from '@/globalStyles';

export enum FQSELECT_VARIANTS {
    fqUnderlined = 'fqUnderlined',
    fqUnderlinedRed = 'fqUnderlinedRed',
    fqOutlined = 'fqOutlined',
}

const FQSelect = styled(Select, { shouldForwardProp: props => props !== 'data-variant' })(props => {
    switch (props['data-variant']) {
        case FQSELECT_VARIANTS.fqUnderlined:
            return {
                minWidth: '8rem',
                '&:before': {
                    borderBottom: `1px solid ${COLOR_FUNCTION.border}`,
                },
                '&:after': {
                    borderColor: COLOR_FUNCTION.selected,
                },
                '.MuiInput-input:focus': {
                    backgroundColor: COLOR.aliceBlue,
                },
                '&.MuiInput-root:hover:not(.Mui-disabled):before': {
                    borderBottom: `2px solid ${COLOR_FUNCTION.border}`,
                },
            };
        case FQSELECT_VARIANTS.fqUnderlinedRed:
            return {
                minWidth: '8rem',
                color: COLOR.redWildWatermelon,
                '&:before': {
                    borderBottom: 'none',
                },
                '&:after': {
                    display: 'none',
                },
                '.MuiInput-input:focus': {
                    backgroundColor: 'transparent',
                },
                '&.MuiInput-root:hover:not(.Mui-disabled):before': {
                    borderBottom: 'none',
                },
                '& .MuiSvgIcon-root.MuiSelect-icon': {
                    fill: COLOR.redWildWatermelon,
                },
            };
        case FQSELECT_VARIANTS.fqOutlined:
            return {
                minWidth: '10rem',
                height: '2.5rem',
                '& .MuiOutlinedInput-input': {
                    padding: '0.6rem 0.875rem',
                },
            };
        default:
            return {};
    }
});

export default FQSelect;
